import { Backend } from '.';

export interface StoreSettings {
  checkout_ask_for_phone: boolean;
  checkout_requires_phone: boolean;
  /**
   * zB "EUR" oder "USD"
   */
  config_currency: string;
  /**
   * zB "€"
   */
  config_currency_symbol: string;
  /**
   * Is the address field in the signup form for newsletter registration required?
   */
  require_address_for_newsletter: boolean;
  /**
   * Is the name in the signup form for newsletter registration required?
   */
  require_name_for_newsletter: boolean;
  shop_ask_for_company_name: boolean;
  shop_customer_requires_email: boolean;
  /**
   * c19 = Covid-19. (Wegen der 2020 Pandemie wurde dieses Feature gebaut.)
   *
   * Frage ob Tickets nach Bestell-Abschluss personalisiert werden müssen.
   */
  use_c19_personalization: boolean;
}

interface SettingsApi {
  store_config: StoreSettings;
  customer: any;
}

export interface CountryMap {
  [key: string]: string;
}

export function getStoreSettings() {
  return Backend.get<SettingsApi>(`/settings`);
}

const cachedCountryMaps = new Map<string, Promise<CountryMap>>();

export function getCountryMap(language: string) {
  if (cachedCountryMaps.has(language)) return cachedCountryMaps.get(language);
  const response = Backend.get<CountryMap>(`/settings/countries`);
  cachedCountryMaps.set(language, response);
  return response;
}
